import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export function Auth0ProviderWithNavigate({ children }) {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_SPA_APPLICATION_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_SPA_APPLICATION_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_AUTH0_SPA_APPLICATION_CALLBACK_URL;
  const audience = process.env.REACT_APP_AUTH0_API_AUDIENCE;
  const scope = process.env.REACT_APP_AUTH0_API_SCOPE;

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={redirectUri}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
      scope={scope}
      cacheLocation={window.Cypress ? "localstorage" : "memory"}
    >
      {children}
    </Auth0Provider>
  );
}
